import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Paper, Box, Container, Grid, Typography, Chip, Collapse } from '@material-ui/core';
import Loader from '../../../../components/Loader';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';

import { loadResumePendent } from 'pages/Transactions/store/thunk';

import useWindowDimensions from 'helpers/hooks/useWindowDimensions';
import { convertFormattedMoneyToNumber, convertToBrl } from '../../../../helpers/converters';

import { useStyles } from '../styles';

function ResumeValues({ value }) {
  return(
    <Grid container justify="center">
      <Grid item>
        <Typography variant="h4" color="primary">
          {value}
        </Typography>
      </Grid>
    </Grid>
  );
}

const Resume = ({ resume, loading }) => {
  const dispatch = useDispatch();

  const classes = useStyles();

  const { width } = useWindowDimensions();
  const isMobile = width < 1024;

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { startDate, endDate } = useSelector(state => state.dateFilter);
  const { qp } = useSelector(state => state.filters);
  const { isResumePendentLoading } = useSelector(state => state.transactions);

  const [isPendentOpen, setIsPendentOpen] = useState(false);

  const { confirmed, pendent } = resume || {};

  useEffect(() => {
    if(isPendentOpen) {
      dispatch(loadResumePendent(userId, establishmentId, { startDate, endDate, qp }));
    }
  }, [isPendentOpen]);

  if(isMobile) {
    return(
      <Paper style={{ marginTop: 10 }}>
        <Grid container style={{ borderLeft: '10px solid transparent' }}>
          <Grid container xs={4} />
          <Grid container xs={4} alignItems='center'>
            <Typography color='primary'>
              <b>Realizado</b>
            </Typography>
          </Grid>
          <Grid container xs={4} alignItems='center' style={{ borderLeft: '1px solid #D7D7D7' }}>
            <Typography color='primary' style={{ marginLeft: 10 }}>
              <b>Previsto</b>
            </Typography>
          </Grid>
        </Grid>
        <Grid container style={{ height: 35, borderLeft: '10px solid #13BC4B' }}>
          <Grid container xs={4} alignItems='center'>
            <Typography color='primary' style={{ marginLeft: 5 }}>
              Total de Receitas
            </Typography>
          </Grid>
          <Grid container xs={4} alignItems='center'>
            <Typography color='primary'>
              {convertToBrl(convertFormattedMoneyToNumber(confirmed?.inbound?.toString()))}
            </Typography>
          </Grid>
          <Grid container xs={4} alignItems='center' style={{ borderLeft: '1px solid #D7D7D7' }}>
            <Typography color='primary' style={{ marginLeft: 10 }}>
              {convertToBrl(convertFormattedMoneyToNumber(pendent?.inbound?.toString()))}
            </Typography>
          </Grid>
        </Grid>
        <Grid container style={{ height: 10, borderLeft: '10px solid transparent' }}>
          <Grid container xs={4} />
          <Grid container xs={4} />
          <Grid container xs={4} style={{ borderLeft: '1px solid #D7D7D7' }} />
        </Grid>
        <Grid container style={{ height: 35, borderLeft: '10px solid #F66C6B' }}>
          <Grid container xs={4} alignItems='center'>
            <Typography color='primary' style={{ marginLeft: 5 }}>
              Total de Despesas
            </Typography>
          </Grid>
          <Grid container xs={4} alignItems='center'>
            <Typography color='primary'>
              {convertToBrl(convertFormattedMoneyToNumber(confirmed?.outbound?.toString()))}
            </Typography>
          </Grid>
          <Grid container xs={4} alignItems='center' style={{ borderLeft: '1px solid #D7D7D7' }}>
            <Typography color='primary' style={{ marginLeft: 10 }}>
              {convertToBrl(convertFormattedMoneyToNumber(pendent?.outbound?.toString()))}
            </Typography>
          </Grid>
        </Grid>
        <Grid container style={{ height: 10, borderLeft: '10px solid transparent' }}>
          <Grid container xs={4} />
          <Grid container xs={4} />
          <Grid container xs={4} style={{ borderLeft: '1px solid #D7D7D7' }} />
        </Grid>
        <Grid container style={{ height: 35, borderLeft: '10px solid #022A5C' }}>
          <Grid container xs={4} alignItems='center'>
            <Typography color='primary' style={{ marginLeft: 5 }}>
              Total de Lucro
            </Typography>
          </Grid>
          <Grid container xs={4} alignItems='center'>
            <Typography color='primary'>
              {convertToBrl(convertFormattedMoneyToNumber(confirmed?.balance?.toString()))}
            </Typography>
          </Grid>
          <Grid container xs={4} alignItems='center' style={{ borderLeft: '1px solid #D7D7D7' }}>
            <Typography color='primary' style={{ marginLeft: 10 }}>
              {convertToBrl(convertFormattedMoneyToNumber(pendent?.balance?.toString()))}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    );
  }

  return(
    <Container className={classes.container}>
      <Grid container spacing={2}>
        <Grid item xs={6} md={12}>
          <Box style={{ paddingTop: 20 }}>
            <Chip
              style={{ backgroundColor: 'rgba(2, 42, 92, 0.2)' }}
              label={
                <Typography color='primary' variant='subtitle1'>Realizado</Typography>
              }
            />
            <Box mt={2}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={4}>
                  <Paper align="center" className={classes.paperSuccess}>
                    <Loader isLoading={loading}>
                      <Typography paragraph color="primary">
                        Total de receitas
                      </Typography>
                      <ResumeValues value={convertToBrl(convertFormattedMoneyToNumber(confirmed?.inbound?.toString()))} />
                    </Loader>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <Paper align="center" className={classes.paperError}>
                    <Loader isLoading={loading}>
                      <Typography paragraph color="primary">
                        Total de despesas
                      </Typography>
                      <ResumeValues value={convertToBrl(convertFormattedMoneyToNumber(confirmed?.outbound?.toString()))} />
                    </Loader>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <Paper align="center" className={classes.paperPrimary}>
                    <Loader isLoading={loading}>
                      <Typography paragraph color="primary">
                        Saldo realizado
                      </Typography>
                      <ResumeValues value={convertToBrl(convertFormattedMoneyToNumber(confirmed?.balance?.toString()))} />
                    </Loader>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} md={12}>
          <Box style={{ paddingTop: 20, paddingBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <Chip
                style={{ backgroundColor: 'rgba(2, 42, 92, 0.2)' }}
                label={
                  <Typography color='primary' variant='subtitle1'>Previsto</Typography>
                }
                onClick={() => setIsPendentOpen(!isPendentOpen)}
              />
              <FontAwesomeIcon
                icon={isPendentOpen ? faCaretDown : faCaretRight}
                color="#022A5C"
                size="lg"
              />
            </div>
            <Collapse in={isPendentOpen}>
              <Box mt={2}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={4}>
                    <Paper align="center" className={classes.paperSuccess}>
                      <Loader isLoading={isResumePendentLoading}>
                        <Typography paragraph color="primary">
                          Total de receitas
                        </Typography>
                        <ResumeValues value={convertToBrl(convertFormattedMoneyToNumber(pendent?.inbound?.toString()))} />
                      </Loader>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <Paper align="center" className={classes.paperError}>
                      <Loader isLoading={isResumePendentLoading}>
                        <Typography paragraph color="primary">
                          Total de despesas
                        </Typography>
                        <ResumeValues value={convertToBrl(convertFormattedMoneyToNumber(pendent?.outbound?.toString()))} />
                      </Loader>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <Paper align="center" className={classes.paperPrimary}>
                      <Loader isLoading={isResumePendentLoading}>
                        <Typography paragraph color="primary">
                          Saldo realizado
                        </Typography>
                        <ResumeValues value={convertToBrl(convertFormattedMoneyToNumber(pendent?.balance?.toString()))} />
                      </Loader>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </Collapse>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

ResumeValues.propTypes = {
  value: PropTypes.string.isRequired
};

Resume.defaultProps = {
  resume: {
    confirmed: {
      inbound: 0,
      outbound: 0,
      balance: 0
    },
    pendent: {
      inbound: 0,
      outbound: 0,
      balance: 0
    }
  }
};

Resume.propTypes = {
  resume: PropTypes.shape({
    confirmed: PropTypes.shape({
      inbound: PropTypes.number,
      outbound: PropTypes.number,
      balance: PropTypes.number
    }),
    pendent: PropTypes.shape({
      inbound: PropTypes.number,
      outbound: PropTypes.number,
      balance: PropTypes.number
    })
  }),
  loading: PropTypes.bool.isRequired
};

export default Resume;